import { render, staticRenderFns } from "./CoozzyAnalyticsIcon.vue?vue&type=template&id=fa6ee020&scoped=true"
import script from "./CoozzyAnalyticsIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyAnalyticsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6ee020",
  null
  
)

export default component.exports